import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const PipelineIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 15, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={(+size * 16) / 15}
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.7907 1.11628C1.86594 1.11628 1.11628 1.86594 1.11628 2.7907C1.11628 3.71545 1.86594 4.46512 2.7907 4.46512C3.71545 4.46512 4.46512 3.71545 4.46512 2.7907C4.46512 1.86594 3.71545 1.11628 2.7907 1.11628ZM0 2.7907C0 1.24944 1.24944 0 2.7907 0C4.33196 0 5.5814 1.24944 5.5814 2.7907C5.5814 4.33196 4.33196 5.5814 2.7907 5.5814C1.24944 5.5814 0 4.33196 0 2.7907Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7209 7.81394C10.7961 7.81394 10.0465 8.56363 10.0465 9.48836C10.0465 10.4131 10.7961 11.1628 11.7209 11.1628C12.6456 11.1628 13.3953 10.4131 13.3953 9.48836C13.3953 8.56363 12.6456 7.81394 11.7209 7.81394ZM8.93018 9.48836C8.93018 7.94708 10.1796 6.69766 11.7209 6.69766C13.2622 6.69766 14.5116 7.94708 14.5116 9.48836C14.5116 11.0296 13.2622 12.2791 11.7209 12.2791C10.1796 12.2791 8.93018 11.0296 8.93018 9.48836Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.7907 11.5349C1.86594 11.5349 1.11628 12.2846 1.11628 13.2093C1.11628 14.134 1.86594 14.8837 2.7907 14.8837C3.71545 14.8837 4.46512 14.134 4.46512 13.2093C4.46512 12.2846 3.71545 11.5349 2.7907 11.5349ZM0 13.2093C0 11.668 1.24944 10.4186 2.7907 10.4186C4.33196 10.4186 5.5814 11.668 5.5814 13.2093C5.5814 14.7506 4.33196 16 2.7907 16C1.24944 16 0 14.7506 0 13.2093Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.79081 11.5349C3.09905 11.5349 3.34895 11.285 3.34895 10.9767V5.02326C3.34895 4.71501 3.09905 4.46512 2.79081 4.46512C2.48256 4.46512 2.23267 4.71501 2.23267 5.02326V10.9767C2.23267 11.285 2.48256 11.5349 2.79081 11.5349Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.79081 4.46512C3.09905 4.46512 3.34895 4.71501 3.34895 5.02326C3.34895 7.18103 5.09816 8.93023 7.25592 8.93023H9.48848C9.79672 8.93023 10.0466 9.18013 10.0466 9.48837C10.0466 9.79662 9.79672 10.0465 9.48848 10.0465H7.25592C4.48166 10.0465 2.23267 7.79751 2.23267 5.02326C2.23267 4.71501 2.48256 4.46512 2.79081 4.46512Z"
        fill="currentColor"
      />
    </svg>
  )
})

PipelineIcon.displayName = 'PipelineIcon'
